import { apiConstants } from '../config';

export default {
    beforeCreate() {
        this.$root.registerModuleStore(apiConstants.code);
    },
    destroyed() {
        this.$root.unregisterModuleStore(apiConstants.code);

    },
};